import assert from 'assert'
import superagent from 'superagent'
import { getAaccessTokenAuthorization } from './getAuthorization'

/**
 * Get orders from ebay
 */
const getPageOfOrders = async (authorization, pageUrl) => {
  try {
    const response = await superagent.get(pageUrl).set('Authorization', authorization)
    return response.body
  } catch (error) {
    console.log(error)
  }
}

const getOrders = async (userAccessToken, lastOrderFetchDate) => {
  const orders = []
  const authorization = getAaccessTokenAuthorization(userAccessToken)

  let pageOfOrders = getFirstPage(lastOrderFetchDate)

  while(pageOfOrders) {
    const ordersPage = await getPageOfOrders(authorization, pageOfOrders)
    orders.push(...(ordersPage.orders))
    pageOfOrders = ordersPage===undefined || ordersPage.next
  }

  return orders
}

const getFirstPage = lastOrderFetchDate => {
  const fromDate = lastOrderFetchDate.toISOString()
  let firstPageUrl = `${process.env.EBAY_ORDERS_ENDPOINT}?offset=0&limit=${process.env.EBAY_ORDERS_DOWNLOAD_PAGE_SIZE||200}`
  firstPageUrl+=`&filter=lastmodifieddate:%5B${fromDate}..%5D`
  return firstPageUrl
}

export default getOrders

assert(process.env.EBAY_ORDERS_ENDPOINT, 'Please set ebay orders url (EBAY_ORDERS_ENDPOINT)')
